module.exports = __webpack_public_path__ + "static/img/draw_area.3446820.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1215/draw_area.png
// module id = 468
// module chunks = 1